import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { navigateToSection } from "../utils/hashSectionNav";
import { useTheme } from "../context/ThemeContext";

export const Navigation = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const isHome = location.pathname === "/";
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* Altura real da barra fixa → --nav-fixed-offset; --nav-fixed-floor no CSS garante respiro mínimo */
  useEffect(() => {
    const el = navRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const gap = 56;
    const apply = () => {
      requestAnimationFrame(() => {
        const h = el.offsetHeight;
        document.documentElement.style.setProperty(
          "--nav-fixed-offset",
          `${Math.ceil(h + gap)}px`
        );
      });
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    const logo = el.querySelector(".styled-logo");
    if (logo && !logo.complete) {
      logo.addEventListener("load", apply, { once: true });
    }
    window.addEventListener("load", apply);
    return () => {
      ro.disconnect();
      window.removeEventListener("load", apply);
      document.documentElement.style.removeProperty("--nav-fixed-offset");
    };
  }, []);

  const logoSrc = "/img/logo.png?v=micbank1";

  const goToSection = (e, sectionId) => {
    e.preventDefault();
    navigateToSection(navigate, location, sectionId);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const urlRegister = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/register" : "indefinido";
  const urlLogin = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/login" : "indefinido";
  
  const navStateClass =
    isHome && !scrolled ? "mic-nav--top" : "mic-nav--scrolled";

  return (
    <nav
      ref={navRef}
      id="menu"
      className={`navbar navbar-default navbar-fixed-top mic-nav ${navStateClass}`}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img
              src={logoSrc}
              alt={props.data ? props.data.nameBank : "Mic Bank"}
              className="styled-logo styled-logo--mic"
            />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right ul-limited">
            <li>
              <a
                href="#about"
                className="page-scroll"
                onClick={(e) => goToSection(e, "about")}
              >
                Sobre nós
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                para sua empresa
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                para você
              </a>
            </li>
            <li className="nav-cta-wrap">
              <div className="nav-cta">
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--ghost"
                  onClick={() => openInNewTab(urlLogin)}
                >
                  Acessar conta
                </button>
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--primary"
                  onClick={() => openInNewTab(urlRegister)}
                >
                  Abrir conta
                </button>
              </div>
            </li>
            <li className="nav-theme-toggle-wrap">
              <button
                type="button"
                className="nav-theme-toggle"
                onClick={toggleTheme}
                aria-label={
                  theme === "dark"
                    ? "Ativar tema claro"
                    : "Ativar tema escuro"
                }
                title={theme === "dark" ? "Tema claro" : "Tema escuro"}
              >
                {theme === "dark" ? <FaSun /> : <FaMoon />}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
